module.exports = __webpack_public_path__ + "assets/img/3_1395_big.c8edbc91.jpg";